import { useMemo } from "react";
import styles from "./StatsBar.module.scss";
import { trendConfig } from "../../core/Patients/trendConfig";

const toNum = (v) => {
  const n = Number(v);
  return Number.isNaN(n) ? null : n;
};

export const StatsBar = ({ healTraj, currentAssess, mcsdAnalysis, trendInfo, surfaceAreaMetric }) => {
  const stats = useMemo(() => {
    if (!healTraj?.length) return null;

    const initialArea = mcsdAnalysis?.initial_surface_area;
    const latestArea = toNum(healTraj[currentAssess]?.dimensions?.surfaceArea?.value);
    const recordType = healTraj[currentAssess]?.recordType ?? "";
    const mcsd = mcsdAnalysis?.threshold_value;
    const mcsdDesc = mcsdAnalysis?.threshold_description;
    const trendStatus = surfaceAreaMetric?.status
    const slope = trendInfo?.slope;
    const r2 = trendInfo?.r_squared;

    return { initialArea, latestArea, mcsd, mcsdDesc, trendStatus, slope, r2, recordType };
  }, [healTraj, mcsdAnalysis, currentAssess, trendInfo, surfaceAreaMetric]);

  if (!stats) return null;

  const {
    color: trendColor,
    icon: trendIcon,
    name: trendName,
  } = trendConfig[stats.trendStatus] || trendConfig.default;

  return (
    <div className={styles.stats_bar}>
      {/* Initial Area */}
      <div className={`${styles.stat_card} ${styles.stat_card_length}`}>
        <span className={styles.stat_label}>Initial Surface Area</span>
        <span className={styles.stat_value}>{stats.initialArea != null ? `${stats.initialArea} cm²` : "—"}</span>
        <span className={styles.stat_sub}>Baseline measurements</span>
      </div>

      {/* Latest Raw */}
      <div className={`${styles.stat_card} ${styles.stat_card_length}`}>
        <span className={styles.stat_label}>{`${stats.recordType} Surface Area`}</span>
        <span className={styles.stat_value}>{stats.latestArea != null ? `${stats.latestArea} cm²` : "—"}</span>
      </div>

      {/* MCSD Threshold */}
      <div className={`${styles.stat_card} ${styles.stat_card_mcsd}`}>
        <span className={styles.stat_label}>MCSD Threshold</span>
        <span className={`${styles.stat_value} ${styles.stat_value_mcsd}`}>{stats.mcsd != null ? `±${stats.mcsd.toFixed(2)} cm²` : "—"}</span>
        {stats.initialArea != null && <span className={styles.stat_sub}>{stats.mcsdDesc}</span>}
      </div>

      {/* Trend */}
      <div className={`${styles.stat_card}`} style={{borderLeftColor: trendColor}}>
        <span className={styles.stat_label}>Trend</span>
        <span className={styles.stat_value} style={{ color: trendColor}}>
          <i className={`${trendIcon}`} style={{ marginRight: 6, fontSize: 16 }} />
          {trendName}
        </span>
        {stats.slope != null && stats.r2 != null && (
          <span className={styles.stat_sub}>
            Slope: {stats.slope.toFixed(2)} cm²/eval · R²: {stats.r2.toFixed(2)}
          </span>
        )}
      </div>
    </div>
  );
};
